import { render, staticRenderFns } from "./Auftraege_Fertig.vue?vue&type=template&id=e3f271bc&scoped=true"
import script from "./Auftraege_Fertig.vue?vue&type=script&lang=js"
export * from "./Auftraege_Fertig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../home/zarzar/Documents/public-solution/bis-office/web/auftragsbuch/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3f271bc",
  null
  
)

export default component.exports